var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFilledGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.6665,
    r: 13,
    fill: "#00A930"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8648 9.02457L13.0639 17.8807L9.10066 13.9174C8.73457 13.5513 8.14113 13.5513 7.77457 13.9174C7.40848 14.2835 7.40848 14.8769 7.77457 15.243L12.4147 19.8836C12.7808 20.2493 13.3743 20.2493 13.7408 19.8836C13.783 19.8414 13.8191 19.7955 13.8519 19.7477L23.1913 10.3506C23.5569 9.98454 23.5569 9.3911 23.1913 9.02457C22.8248 8.65848 22.2313 8.65848 21.8648 9.02457Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilledGreen);
export default __webpack_public_path__ + "static/media/checkFilledGreen.c05de0697d68bba464d0b34d474beb28.svg";
export { ForwardRef as ReactComponent };